import { Message } from '@softura/fluentuipackage'
import './Alert.scss'

interface IProps {
  className?:string,
  text?:any,
  type?:string,
  truncated?:any,
  isMultiline?:any,
  showAlert?:any,
  dismissAlert?:any,
  'data-attribute'?: any,
}
const AlertContainer = ({showAlert, dismissAlert, className, text, type='info', truncated="false", 'data-attribute': dataAttribute}:IProps ) => {
  return (<>
    <Message
      className={`alert-msg ${className}`}
      show={showAlert} 
      onDismiss={dismissAlert}
      text={text}
      type={type}
      truncated={truncated}
      isMultiline={truncated}
      data-attribute={dataAttribute}
    />
  </>)
}

export default AlertContainer
